import script from "./paperList.vue?vue&type=script&lang=ts&setup=true"
export * from "./paperList.vue?vue&type=script&lang=ts&setup=true"

import "./paperList.vue?vue&type=style&index=0&id=918c023a&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-918c023a"]])

export default __exports__